//import { createIcon } from "@chakra-ui/icons";
import { chakra, forwardRef, ImageProps } from "@chakra-ui/react";
import fingerprint from "./fingerprint.svg";
import ckb from "./ckb.svg";
import eth from "./ethereum.svg";
import arbNova from "./arbitrum-nova.svg";
import base from "./base.svg";
import bnb from "./bnb.svg";
import linea from "./linea.svg";
import pgn from "./pgn.svg";
import polygon from "./polygon.svg";
import scroll from "./scroll.svg";
import taiko from "./taiko.svg";
import zksync from "./zksync.svg";
import zora from "./zora.svg";
import joyid from "./joyid.svg";
import metamask from "./metamask.svg";
import starknet from "./starknet.svg";

export const CkbIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={ckb} width="1em" height="1em" ref={ref} {...props} />
});

export const EthIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={eth} width="1em" height="1em" ref={ref} {...props} />
});
export const ArbNovaIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={arbNova} width="1em" height="1em" ref={ref} {...props} />
});
export const BaseIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={base} width="1em" height="1em" ref={ref} {...props} />
});
export const OpBnbIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={bnb} width="1em" height="1em" ref={ref} {...props} />
});
export const GodwokenIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src="https://godwoken.com/images/footer-logo.png" width="1em" height="1em" ref={ref} {...props} />
});
export const LineaIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={linea} width="1em" height="1em" ref={ref} {...props} />
});
export const PgnIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={pgn} width="1em" height="1em" ref={ref} {...props} />
});
export const PolygonIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={polygon} width="1em" height="1em" ref={ref} {...props} />
});
export const ScrollIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={scroll} width="1em" height="1em" ref={ref} {...props} />
});
export const TaikoIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={taiko} width="1em" height="1em" ref={ref} {...props} />
});
export const ZkSyncIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={zksync} width="1em" height="1em" ref={ref} {...props} />
});
export const ZoraIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={zora} width="1em" height="1em" ref={ref} {...props} />
});

export const JoyIDIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={joyid} ref={ref} width="2em" height="2em" {...props} />
});
export const MetaMaskIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={metamask} ref={ref} width="2em" height="2em" {...props} />
});
export const StarkNetIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={starknet} ref={ref} width="2em" height="2em" {...props} />
});

// export const StacksIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
//     return <chakra.img src="https://docs.stacks.co/img/stacks_with_interior_white_exterior_transparent.png" ref={ref} width="1em" height="1em" {...props} />
// });

export const FingerprintIcon = forwardRef<ImageProps, "img">((props: any, ref: any) => {
    return <chakra.img src={fingerprint} ref={ref} width="1em" height="1em" {...props} />
});
